import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import React, { useEffect, useState } from 'react';
import { Input } from 'ui';
import useFacetFiltering from '~/contexts/facetFiltering/useFacetFiltering';

interface Props {}

const FilterKeywordSearch: React.FC<Props> = () => {
  const { changeFacetSelection, filterState } = useFacetFiltering();

  const [value, setValue] = useState(filterState.q || '');

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setValue(e.target.value);
  }

  useEffect(() => {
    setValue(filterState.q || '');
  }, [filterState.q]);

  return (
    <form
      className="w-full"
      onSubmit={e => {
        e.preventDefault();
        changeFacetSelection('q', value || null);
      }}
    >
      <Input
        onChange={handleChange}
        value={value}
        type="search"
        className="w-full"
        id="filter-by-keyword"
        placeholder="Search within results"
        rightAdornment={
          <button type="submit" className="h-10 pl-3" aria-hidden="true">
            <MagnifyingGlassIcon className="mr-3 h-5 w-5" />
          </button>
        }
      />
    </form>
  );
};

export default FilterKeywordSearch;
